import { TagCategory } from "../../model/tag/TagCategory";
import { api } from "../api";
import { parseTagCategory } from "../../parsers/tags/parseTagCategory";

export const getTagCategories = async (): Promise<TagCategory[]> => {
  const response = await api.services.tagCategories.getAllTagCategories();
  return response.data.map(parseTagCategory);
};
